// extracted by mini-css-extract-plugin
module.exports = {"new_main_page_wrapper":"MainPage_new_main_page_wrapper__3Oe_w"};